import React from "react";

export default function CustomersByOrderTotals() {
  const customers = [
    {
      customer: "arthur_holmes@routekart.com",
      orderTotal: "$2,460.00",
      orders: 1,
    },
    {
      customer: "steve_gates@routekart.com",
      orderTotal: "$1,855.00",
      orders: 1,
    },
    {
      customer: "brenda_lindgren@routekart.com",
      orderTotal: "$102.00",
      orders: 1,
    },
    {
      customer: "victoria_victoria@routekart.com",
      orderTotal: "$43.50",
      orders: 1,
    },
    {
      customer: "james_pan@routekart.com",
      orderTotal: "$8.80",
      orders: 1,
    },
  ];

  return (
    <div className="p-4 md:p-6 bg-gray-50 min-h-screen">
      {/* Title */}
      <h1 className="text-xl font-semibold text-gray-800 mb-4">
        Customers by Order Total
      </h1>

      {/* Filters Section */}
      <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-6 gap-3 mb-6">
        <input
          type="text"
          placeholder="Search"
          className="border rounded-lg px-3 py-2 text-sm w-full"
        />
        <input
          type="text"
          placeholder="Start date (dd/mm/yyyy)"
          className="border rounded-lg px-3 py-2 text-sm w-full"
        />
        <input
          type="text"
          placeholder="End date (dd/mm/yyyy)"
          className="border rounded-lg px-3 py-2 text-sm w-full"
        />
        <select className="border rounded-lg px-3 py-2 text-sm w-full">
          <option>Order status</option>
          <option>Pending</option>
          <option>Completed</option>
          <option>Cancelled</option>
        </select>
        <select className="border rounded-lg px-3 py-2 text-sm w-full">
          <option>Payment status</option>
          <option>Paid</option>
          <option>Unpaid</option>
        </select>
        <select className="border rounded-lg px-3 py-2 text-sm w-full">
          <option>Shipping status</option>
          <option>Shipped</option>
          <option>Pending</option>
        </select>
      </div>

      {/* Learn More */}
      <a
        href="#"
        className="text-blue-600 text-sm hover:underline mb-4 inline-block"
      >
        Learn more about reports
      </a>

      {/* Table */}
      <div className="overflow-x-auto bg-white rounded-lg shadow-sm">
        <table className="min-w-full text-sm text-left">
          <thead className="bg-gray-100 text-gray-700">
            <tr>
              <th className="py-3 px-4 font-medium">Customer</th>
              <th className="py-3 px-4 font-medium">Order Total</th>
              <th className="py-3 px-4 font-medium">Number of Orders</th>
              <th className="py-3 px-4 font-medium">View</th>
            </tr>
          </thead>
          <tbody>
            {customers.map((c, i) => (
              <tr key={i} className="border-t hover:bg-gray-50">
                <td className="py-3 px-4">{c.customer}</td>
                <td className="py-3 px-4">{c.orderTotal}</td>
                <td className="py-3 px-4">{c.orders}</td>
                <td className="py-3 px-4">
                  <button className="text-blue-600 hover:underline">
                    View
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <div className="flex flex-col md:flex-row items-center justify-between mt-4 text-sm text-gray-600">
        {/* Prev / Next */}
        <div className="flex items-center gap-2 mb-2 md:mb-0">
          <button className="px-3 py-1 border rounded hover:bg-gray-100">
            Previous
          </button>
          <span>1</span>
          <button className="px-3 py-1 border rounded hover:bg-gray-100">
            Next
          </button>
        </div>

        {/* Show items */}
        <div className="flex items-center gap-2 mb-2 md:mb-0">
          <span>Show</span>
          <select className="border border-gray-300 rounded-md px-2 py-1">
            <option>15</option>
            <option>30</option>
            <option>50</option>
          </select>
          <span>items</span>
        </div>

        {/* Range info */}
        <p>1–5 of 5 items</p>
      </div>

      {/* Footer */}
      <p className="text-gray-400 text-xs mt-6 text-center">
        Powered by routekart Reports
      </p>
    </div>
  );
}
